const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "commercial",
      title: "Commercial",
      icon: "img/icons/projectIcon/commercial_icon.png",
      path: "/commercial"
    },
    {
      code: "reporting",
      title: "Reporting",
      icon: "img/icons/projectIcon/report_icon.png",
      path: "/reporting"
    },
    {
      code: "design",
      title: "Design",
      icon: "img/icons/projectIcon/design_icon.png",
      path: "/design"
    },
    {
      code: "collaboration",
      title: "Collaboration",
      icon: "img/icons/projectIcon/collab_icon.png",
      path: "/collaboration"
    },
    {
      code: "management",
      title: "Management",
      icon: "img/icons/projectIcon/management_icon.png",
      path: "/management"
    },
    {
      code: "virtualreality",
      title: "Virtual Reality",
      icon: "img/icons/projectIcon/innovation_icon.png",
      path: "/virtualreality"
    },
    // {
    //   code: "innovation",
    //   title: "Research and Innovation",
    //   icon: "img/icons/projectIcon/innovation_icon.png",
    //   path: "/innovation"
    // },
  ],
  categories: {
    commercial: [
      "Cost (Capex)",
      "Cost (Opex)",
      "Procurement and Supply Chain",
      "Contract"
    ],
    reporting: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    design: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    collaboration: [
      "Correspondence Management",
      "File Transfer",
      "Contact List",
      "Meetings",
      "Action Lists",
      "Risk and Issue Management",
      "Document Management",
      "Shared Calendar",
      "Interface Management",
      "Stakeholder Management"
    ],
    management: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    virtualreality: [
      "Virtual Reality"
    ]
    // innovation: [
    //   "Innovation"
    // ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false
  },
  portfolios: [
    {
      code: "portfolio",
      title: "Portfolio"
    }
    // {
    //   code: "passenger_service",
    //   title: "Passenger Services"
    // },
    // {
    //   code: "other_lines",
    //   title: "Other Lines"
    // },
    // {
    //   code: "closed_lines",
    //   title: "Closed Lines"
    // },

  ],
  projects: {
    portfolio: [
      "CRE"
      // "Tottenham to Albury (T2A)",
      // "Albury to Illabo (A2I)",
      // "Illabo to Stockinbingal (I2S)",
      // "Stockinbingal to Parkes (S2P)",
      // "Parkes to Narromine (P2N)",
      // "Narromine to Narrabri (N2N)",
      // "Narrabri to North Star (N2NS)",
      // "North Star to Border (NS2B)",
      // "Border to Gowrie (B2G)",
      // "Gowrie to Helidon (G2H)",
      // "Helidon to Calvert (H2C)",
      // "Calvert to Kaguru (C2K)",
      // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
    ]
    // passenger_service: [
    //   "Muswellbrook",
    //   "Station A",
    //   "Station B",
    //   "Station C",
    //   "Station D"
    // ],
    // other_lines: [
    //   "Station E",
    //   "Station F",
    //   "Station G",
    //   "Station H",
    //   "Station I"
    // ],
    // closed_lines: [
    //   "Station J",
    //   "Station K",
    //   "Station L",
    //   "Station M",
    //   "Station N"
    // ]
  },
  projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        }
      ]
    },
    {
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "virtualreality",
      items: [
        {
          category: "Virtual Reality",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "",
              imgUrl: "img/assets/tabs/InfoExchangeTab.png"
            },
            {
              title: "2D VIEW",
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "3D VIEW",
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewTab.png"
            }
          ]
        }
      ]
    }
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Dock",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Parramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "commercial",
        title: "Commercial",
        icon: "img/icons/projectIcon/commercial_icon.png",
        path: "/commercial"
      },
      {
        code: "reporting",
        title: "Reporting",
        icon: "img/icons/projectIcon/report_icon.png",
        path: "/reporting"
      },
      {
        code: "design",
        title: "Design",
        icon: "img/icons/projectIcon/design_icon.png",
        path: "/design"
      },
      {
        code: "collaboration",
        title: "Collaboration",
        icon: "img/icons/projectIcon/collab_icon.png",
        path: "/collaboration"
      },
      {
        code: "management",
        title: "Management",
        icon: "img/icons/projectIcon/management_icon.png",
        path: "/management"
      },
      {
        code: "virtualreality",
        title: "Virtual Reality",
        icon: "img/icons/projectIcon/innovation_icon.png",
        path: "/virtualreality"
      },
      // {
      //   code: "innovation",
      //   title: "Research and Innovation",
      //   icon: "img/icons/projectIcon/innovation_icon.png",
      //   path: "/innovation"
      // },
    ],
    categories: {
      commercial: [
        "Cost (Capex)",
        "Cost (Opex)",
        "Procurement and Supply Chain",
        "Contract"
      ],
      reporting: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      design: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      collaboration: [
        "Correspondence Management",
        "File Transfer",
        "Contact List",
        "Meetings",
        "Action Lists",
        "Risk and Issue Management",
        "Document Management",
        "Shared Calendar",
        "Interface Management",
        "Stakeholder Management"
      ],
      management: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      virtualreality: [
        "Virtual Reality"
      ]
      // innovation: [
      //   "Innovation"
      // ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false
    },
    portfolios: [
      {
        code: "portfolio",
        title: "Portfolio"
      }
      // {
      //   code: "passenger_service",
      //   title: "Passenger Services"
      // },
      // {
      //   code: "other_lines",
      //   title: "Other Lines"
      // },
      // {
      //   code: "closed_lines",
      //   title: "Closed Lines"
      // },

    ],
    projects: {
      portfolio: [
        "CRE"
        // "Tottenham to Albury (T2A)",
        // "Albury to Illabo (A2I)",
        // "Illabo to Stockinbingal (I2S)",
        // "Stockinbingal to Parkes (S2P)",
        // "Parkes to Narromine (P2N)",
        // "Narromine to Narrabri (N2N)",
        // "Narrabri to North Star (N2NS)",
        // "North Star to Border (NS2B)",
        // "Border to Gowrie (B2G)",
        // "Gowrie to Helidon (G2H)",
        // "Helidon to Calvert (H2C)",
        // "Calvert to Kaguru (C2K)",
        // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
      ]
      // passenger_service: [
      //   "Muswellbrook",
      //   "Station A",
      //   "Station B",
      //   "Station C",
      //   "Station D"
      // ],
      // other_lines: [
      //   "Station E",
      //   "Station F",
      //   "Station G",
      //   "Station H",
      //   "Station I"
      // ],
      // closed_lines: [
      //   "Station J",
      //   "Station K",
      //   "Station L",
      //   "Station M",
      //   "Station N"
      // ]
    },
    projectTabs: [
      {
        zoneCode: "commercial",
        items: [
          {
            category: "Cost (Capex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Cost (Opex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Procurement and Supply Chain",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Contract",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "reporting",
        items: [
          {
            category: "Monthly",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Weekly",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Live",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "design",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "collaboration",
        items: [
          {
            category: "Correspondence Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "File Transfer",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Contact List",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Meetings",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Action Lists",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Risk and Issue Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Document Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Shared Calendar",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Interface Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Stakeholder Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          }
        ]
      },
      {
        zoneCode: "management",
        items: [
          {
            category: "Management Plans",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Passport (Inductions)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Resource Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Planning and Scheduling",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Change Control",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
          {
            category: "Health and Safety",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "virtualreality",
        items: [
          {
            category: "Virtual Reality",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: ""
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              }
            ]
          }
        ]
      }
    ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
